import React, { useEffect } from 'react';
import { Alert, Button, Col, Form, Row } from 'react-bootstrap';

import { isEmail } from 'app/shared/util/validation';

import { useForm } from 'react-hook-form';
import { toast } from 'react-toastify';

import { useAppDispatch, useAppSelector } from 'app/config/store';
import { handlePasswordResetInit, reset } from '../password-reset.reducer';

interface ResetInitFormValues {
  email: string;
}

export const PasswordResetInit = () => {
  const dispatch = useAppDispatch();

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm<ResetInitFormValues>({ mode: 'onTouched' });

  useEffect(
    () => () => {
      dispatch(reset());
    },
    [],
  );

  const handleValidSubmit = ({ email }: ResetInitFormValues) => {
    dispatch(handlePasswordResetInit(email));
  };

  const successMessage = useAppSelector(state => state.passwordReset.successMessage);

  useEffect(() => {
    if (successMessage) {
      toast.success(successMessage);
    }
  }, [successMessage]);

  return (
    <div>
      <Row className="justify-content-center">
        <Col md="8">
          <h1>Restablecer su contraseña</h1>
          <Alert variant="warning">
            <p>Introduzca la dirección de correo electrónico que utilizó para registrarse</p>
          </Alert>
          <Form onSubmit={handleSubmit(handleValidSubmit)}>
            <Form.Group className="mb-3" controlId="email">
              <Form.Label>Correo electrónico</Form.Label>
              <Form.Control
                type="email"
                placeholder="Su correo electrónico"
                data-cy="emailResetPassword"
                isInvalid={!!errors.email}
                {...register('email', {
                  required: { value: true, message: 'Se requiere un correo electrónico.' },
                  minLength: { value: 5, message: 'Se requiere que su correo electrónico tenga por lo menos 5 caracteres' },
                  maxLength: { value: 254, message: 'Su correo electrónico no puede tener más de 50 caracteres' },
                  validate: v => isEmail(v) || 'Su correo electrónico no es válido.',
                })}
              />
              <Form.Control.Feedback type="invalid">{errors.email?.message}</Form.Control.Feedback>
            </Form.Group>
            <Button variant="primary" type="submit" data-cy="submit">
              Restablecer la contraseña
            </Button>
          </Form>
        </Col>
      </Row>
    </div>
  );
};

export default PasswordResetInit;
